module.exports = __webpack_public_path__ + "media/assets/ChevronLight-c212c98e6e2c3359d1d217a7731d40eb.svg";